
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsionAzimuthThruster as ObiPropulsionAzimuthThrusterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion-azimuth-thruster.js';
 
 
 

 
 export const ObiPropulsionAzimuthThruster = createComponent({
   react: React,
   tagName: 'obi-propulsion-azimuth-thruster',
   elementClass: ObiPropulsionAzimuthThrusterElement,
   events: {
     
   }
  });
 
 